import React from 'react';
import EmbeddedApp from '../../components/embeddedApp/embeddedApp';

const OtaService = () => (
  <EmbeddedApp
    audience="ota"
    title="OTA Service"
    buildIframeSrc={(code) => `https://ota.mavistech.uk/sso/${code}/`}
  />
);

export default OtaService;
